import { Component } from '@angular/core';
import { FormLabelTranslationService } from '~shared/components/form-fields/translations/form-label-translations.service';

/**
 * Base component for the sidebar content.
 */
@Component({
  template: ''
})
export class ClubFormsExtensionComponent {
  constructor(public flTranslations: FormLabelTranslationService) {
  }

}
